import React, { Component } from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CartContext from "./CartContext";
import { DemoButton } from "./CommonModules";

export class Accounting extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const ctx = this.context || {};
    const {
      userData,
      ShowUserLoginNew,
      prods,
      SetSelectedProduct,
      ProductType,
    } = ctx;

    if (!userData || userData.loginStatus !== "active") {
      if (typeof ShowUserLoginNew === "function") ShowUserLoginNew(true);
      return;
    }

    const accType = ProductType?.Accounting || ProductType?.Finance;
    if (accType && Array.isArray(prods)) {
      const selected = prods.find((p) => p.productType === accType);
      if (selected && typeof SetSelectedProduct === "function") {
        SetSelectedProduct(selected);
        return;
      }
    }

    if (typeof ctx.HandleTryNowButtonClick === "function") {
      ctx.HandleTryNowButtonClick(accType);
    }
  };

  render() {
    const ctx = this.context || {};
    if (!ctx?.EcSettings || ctx.EcSettings.length === 0) return <></>;

    const base = ctx.GetEcSettingValueByName?.("StorageBlobImageUrl") || "";

    const modules = [
      {
        title: "Dashboard",
        desc: "Quick view of financial health, KPIs and reports.",
      },
      {
        title: "Account Category",
        desc: "Organize accounts by type for clear reporting.",
      },
      {
        title: "Debits [Expenses]",
        desc: "Record and manage all business expenses.",
      },
      {
        title: "Credits [Revenues]",
        desc: "Track sales revenue and incoming funds.",
      },
      {
        title: "Receivable (AR)",
        desc: "Invoices, customer balances, and collections.",
      },
      {
        title: "Payable (AP)",
        desc: "Vendor bills, due payments, and approvals.",
      },
      {
        title: "Employee Payroll",
        desc: "Automated salary runs, payslips, and tax deductions.",
      },
      {
        title: "Bank Accounts",
        desc: "Maintain multiple bank accounts and balances.",
      },
      {
        title: "Bank Reconciliation",
        desc: "Match books with bank statements easily.",
      },
      {
        title: "Ledger",
        desc: "Core accounting ledger with debits and credits.",
      },
    ];

    return (
      <>
        {/* Hero / Marketing Section */}
        <section className="hero container-fluid py-5 bg-white">
          <div className="container">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="badge-sub">
                  Accounting • Finance Management
                </span>
                <h1 className="display-5 fw-bold mt-3">
                  Manage Finances, Payroll & Compliance with Ease
                </h1>
                <p className="lead text-muted mb-4">
                  ElasticCART Accounting gives you complete control over your
                  business finances — from expenses and revenue tracking to
                  payroll, receivables, payables, and reconciliations.
                </p>
                <div className="mt-4">
                  {/* <Button
                    variant="light"
                    size="lg"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-play me-2" /> Book a demo
                    +91-98805 82728
                  </Button> */}
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={this.handleTryNow}
                    as={Link}
                    to="/Checkout"
                  >
                    <i className="fa-solid fa-flask me-2" /> Start free trial
                  </Button>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="card card-feature p-4 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Key Benefits</h5>
                    <ul className="list-unstyled small text-muted">
                      <li>✔ Real-time dashboards with KPIs</li>
                      <li>✔ Expense & Revenue tracking</li>
                      <li>✔ Automated Payroll & Compliance</li>
                      <li>✔ Receivables & Payables Management</li>
                      <li>✔ Bank accounts & reconciliation</li>
                      <li>✔ Comprehensive Ledger & Reports</li>
                    </ul>
                  </div>
                </div>
                <DemoButton></DemoButton>
              </div>

              {/* Demo Video */}
              {/* <div className="col-lg-12 my-5">
                <video controls height="400px" autoPlay muted loop width="100%">
                  <source src={base + "AccountingVideo.mp4"} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div> */}
            </div>
          </div>
        </section>

        {/* Accounting Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3">
            Explore Accounting Modules
          </h5>
          <Row className="g-3">
            {modules.map((m, idx) => (
              <Col md={6} lg={4} key={idx}>
                <Card className="bg-light shadow-sm h-100 hover-shadow">
                  <Card.Body>
                    <h6>{m.title}</h6>
                    <p className="small text-muted">{m.desc}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

export default Accounting;
